import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Table variants - shadcn-style table with project design tokens
 *
 * Design tokens from tailwind.config.js:
 * - text-color (#1c1b21) - Table text
 * - border-color (#e5e5e5) - Table borders
 * - cards-bg - Striped row background
 * - font-main-font (Poppins) - Table font
 */

export const tableVariants = cva('w-full caption-bottom text-sm font-main-font', {
  variants: {
    variant: {
      default: '',
      bordered: 'border',
      striped: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export const tableBodyVariants = cva('[&_tr:last-child]:border-0')

export const tableRowVariants = cva(
  'border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted',
  {
    variants: {
      variant: {
        default: '',
        striped: 'even:bg-cards-bg',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const tableCellVariants = cva(
  'p-4 align-middle text-text-color [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
  {
    variants: {
      size: {
        default: 'p-4',
        sm: 'p-2',
        lg: 'p-6',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

// Type exports
export type TableVariants = VariantProps<typeof tableVariants>
export type TableRowVariants = VariantProps<typeof tableRowVariants>
export type TableCellVariants = VariantProps<typeof tableCellVariants>
